export default __webpack_public_path__ + "static/media/area-chart.66b76151.svg";